export function ownerProjectNextAction(value) {
  if (!value) return null;
  return value.nextAction || value;
}

export function ownerProjectNextActionText(value, fallback = "") {
  const nextAction = ownerProjectNextAction(value);
  if (!nextAction || nextAction.source === "none") return fallback;
  const title = String(nextAction.title || "").trim();
  if (nextAction.source === "commitment") {
    const state = String(nextAction.state || nextAction.commitment?.work?.state || "ready");
    if (state === "waiting") {
      const waitingFor = String(nextAction.commitment?.work?.waitingFor || "").trim();
      return waitingFor ? `Esperando: ${waitingFor}` : title;
    }
    if (state === "blocked") {
      const blockedReason = String(nextAction.commitment?.work?.blockedReason || nextAction.commitment?.work?.blockedBy || "").trim();
      return blockedReason ? `Bloqueado por: ${blockedReason}` : title;
    }
    const executionCode = String(nextAction.executability?.code || nextAction.commitment?.executability?.code || "");
    if (executionCode.startsWith("dependency_")) {
      const dependencyTitle = String(nextAction.executability?.dependency?.title || nextAction.commitment?.executability?.dependency?.title || nextAction.commitment?.dependency?.title || "").trim();
      return dependencyTitle ? `No disponible: primero falta ${dependencyTitle}` : `Tiene una dependencia pendiente: ${title}`;
    }
  }
  return title || fallback;
}

export function ownerProjectNextActionLabel(value) {
  const nextAction = ownerProjectNextAction(value);
  if (!nextAction || nextAction.source === "none") return "PRÓXIMA ACCIÓN";
  if (nextAction.source === "legacy") return "PRÓXIMO PASO RESUMIDO";
  if (nextAction.executable === false) return "ESTADO OPERATIVO";
  return "PRÓXIMA ACCIÓN";
}
